const EventCard = (props) => {
    return (
        <>
            {/* <!--Cause Block--> */}
            <article className={`yk-events-story${props.i_featured ? ' yk-events-story--lead' : ''}`}>
                <a href={props.Link} className="yk-events-photo" aria-label={props.title}>
                    <img src={props.imgsrc} alt={props.title} loading="lazy" decoding="async" />
                </a>
                {/* <!-- <div className="bar">
                                    <div className="bar-inner count-bar" data-percent="80%"><div className="count-text">80%</div></div>
                                </div> --> */}
                <div className="yk-events-body">
                    <h3 className="yk-events-title"><a href={props.Link}>{props.title}</a></h3>
                    {/* <!-- <div className="cause-title">Medicine</div> --> */}
                    <p className="yk-events-description">{props.Desc}</p>
                    {/* <!-- <div className="donate-info clearfix">
                                <div className="goal"><i className="fa fa-crosshairs"></i> <span>Goal:</span> <strong>$10,000</strong> </div>
                                <div className="raised"><i className="fa fa-chart-line"></i> <span>Raised:</span> <strong>$6,500</strong> </div>
                            </div> --> */}
                </div>
            </article>
        </>
    );
};

export default EventCard;
